const autoNgTemplateLoaderTemplate1 = require('./entity-dashboard.template.html');

'use strict';

(function () {
    angular
        .module('app.entityDashboard', [])
        .config(entityDashboardConfig);

    entityDashboardConfig.$inject = ['$routeProvider'];

    function entityDashboardConfig($routeProvider) {
        $routeProvider
            .when('/entity-dashboard', {
                disableCache: true,
                templateUrl: autoNgTemplateLoaderTemplate1,
                controller: 'EntityDashboardController',
                controllerAs: 'vm',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                }
            })
    }
})();
